import React, { useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Comments from "./Comments";

const FormSelect = React.forwardRef(
  (
    {
      name,
      label,
      options,
      value,
      placeholder,
      error,
      onChange,
      commentsFactory,
      identical,
      divClassName,
      labelClassName,
      marginBottomOverride,
      ...rest
    },
    ref
  ) => {
    const [showComments, setShowComments] = useState(false);

    const toggleComments = () => {
      setShowComments(!showComments);
    };

    const comments = commentsFactory?.get(name);

    return (
      <div
        className={`${!marginBottomOverride ? "mb-3" : marginBottomOverride}${
          divClassName ? ` ${divClassName}` : ""
        }`}
        {...rest}
      >
        {comments && showComments ? (
          <Comments comments={comments} commentsFactory={commentsFactory} />
        ) : null}
        {identical && (
          <i className="fab fa-searchengin text-danger float-end mb-2 ms-2 d-print-none"></i>
        )}
        {label && (
          <label
            htmlFor={name}
            className={`form-label${
              labelClassName ? ` ${labelClassName}` : ""
            }`}
          >
            {label}
            {comments?.length > 0 ? (
              <i
                className="fas fa-comment-alt text-warning m-2"
                onClick={toggleComments}
              />
            ) : null}
          </label>
        )}
        <select
          name={name}
          id={name}
          value={value}
          {...rest}
          className="form-select border-secondary d-print-none"
          onChange={onChange}
          ref={ref}
        >
          {placeholder ? (
            <option value="">{placeholder}</option>
          ) : (
            <option value="" />
          )}
          {options &&
            options.map((option, index) => (
              <option
                key={`${option._id}${index}`}
                value={option._id}
                title={option.title}
              >
                {option.name}
              </option>
            ))}
        </select>
        <label className="d-none d-print-block">
          {options &&
          options.filter((option) => option._id === value).length === 1
            ? options.filter((option) => option._id === value)[0].name
            : ""}
        </label>
        {error && <div className="mt-1 alert alert-danger">{error}</div>}
      </div>
    );
  }
);

export default FormSelect;
